/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandInfringementThreatTypeEnum } from './BrandInfringementThreatTypeEnum';
import {
    BrandInfringementThreatTypeEnumFromJSON,
    BrandInfringementThreatTypeEnumFromJSONTyped,
    BrandInfringementThreatTypeEnumToJSON,
    BrandInfringementThreatTypeEnumToJSONTyped,
} from './BrandInfringementThreatTypeEnum';
import type { InfringementEvent } from './InfringementEvent';
import {
    InfringementEventFromJSON,
    InfringementEventFromJSONTyped,
    InfringementEventToJSON,
    InfringementEventToJSONTyped,
} from './InfringementEvent';
import type { BrandInfringementSeverityEnum } from './BrandInfringementSeverityEnum';
import {
    BrandInfringementSeverityEnumFromJSON,
    BrandInfringementSeverityEnumFromJSONTyped,
    BrandInfringementSeverityEnumToJSON,
    BrandInfringementSeverityEnumToJSONTyped,
} from './BrandInfringementSeverityEnum';
import type { Status7f3Enum } from './Status7f3Enum';
import {
    Status7f3EnumFromJSON,
    Status7f3EnumFromJSONTyped,
    Status7f3EnumToJSON,
    Status7f3EnumToJSONTyped,
} from './Status7f3Enum';

/**
 * 
 * @export
 * @interface BrandInfringement
 */
export interface BrandInfringement {
    /**
     * 
     * @type {number}
     * @memberof BrandInfringement
     */
    readonly id: number;
    /**
     * Title of the threat (e.g., news title, social media post, domain name)
     * @type {string}
     * @memberof BrandInfringement
     */
    threatTitle: string;
    /**
     * Type of brand infringement threat
     * 
     * * `domain_threat` - Domain Threat
     * * `social_media` - Social Media
     * * `public_news` - Public News
     * @type {BrandInfringementThreatTypeEnum}
     * @memberof BrandInfringement
     */
    threatType: BrandInfringementThreatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandInfringement
     */
    readonly threatTypeDisplay: string;
    /**
     * Source where the threat was detected
     * @type {string}
     * @memberof BrandInfringement
     */
    source: string;
    /**
     * Severity level of the threat
     * 
     * * `critical` - Critical
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     * * `info` - Informational
     * @type {BrandInfringementSeverityEnum}
     * @memberof BrandInfringement
     */
    severity?: BrandInfringementSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandInfringement
     */
    readonly severityDisplay: string;
    /**
     * Confidence level from 0-100%, null indicates Unknown
     * @type {number}
     * @memberof BrandInfringement
     */
    confidenceLevel?: number | null;
    /**
     * Current status of the infringement investigation
     * 
     * * `new` - New
     * * `detected` - Detected
     * * `investigating` - Investigating
     * * `reported` - Reported
     * * `takendown` - Taken Down
     * @type {Status7f3Enum}
     * @memberof BrandInfringement
     */
    status?: Status7f3Enum;
    /**
     * 
     * @type {string}
     * @memberof BrandInfringement
     */
    readonly statusDisplay: string;
    /**
     * Screenshot of the infringing content
     * @type {string}
     * @memberof BrandInfringement
     */
    screenshot?: string | null;
    /**
     * Detailed description of the infringement
     * @type {string}
     * @memberof BrandInfringement
     */
    description?: string;
    /**
     * Date when the infringement was detected
     * @type {Date}
     * @memberof BrandInfringement
     */
    readonly dateDetected: Date;
    /**
     * 
     * @type {Array<InfringementEvent>}
     * @memberof BrandInfringement
     */
    readonly timelineEvents: Array<InfringementEvent>;
    /**
     * 
     * @type {Date}
     * @memberof BrandInfringement
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BrandInfringement
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the BrandInfringement interface.
 */
export function instanceOfBrandInfringement(value: object): value is BrandInfringement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('threatTitle' in value) || value['threatTitle'] === undefined) return false;
    if (!('threatType' in value) || value['threatType'] === undefined) return false;
    if (!('threatTypeDisplay' in value) || value['threatTypeDisplay'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('severityDisplay' in value) || value['severityDisplay'] === undefined) return false;
    if (!('statusDisplay' in value) || value['statusDisplay'] === undefined) return false;
    if (!('dateDetected' in value) || value['dateDetected'] === undefined) return false;
    if (!('timelineEvents' in value) || value['timelineEvents'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function BrandInfringementFromJSON(json: any): BrandInfringement {
    return BrandInfringementFromJSONTyped(json, false);
}

export function BrandInfringementFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandInfringement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'threatTitle': json['threat_title'],
        'threatType': BrandInfringementThreatTypeEnumFromJSON(json['threat_type']),
        'threatTypeDisplay': json['threat_type_display'],
        'source': json['source'],
        'severity': json['severity'] == null ? undefined : BrandInfringementSeverityEnumFromJSON(json['severity']),
        'severityDisplay': json['severity_display'],
        'confidenceLevel': json['confidence_level'] == null ? undefined : json['confidence_level'],
        'status': json['status'] == null ? undefined : Status7f3EnumFromJSON(json['status']),
        'statusDisplay': json['status_display'],
        'screenshot': json['screenshot'] == null ? undefined : json['screenshot'],
        'description': json['description'] == null ? undefined : json['description'],
        'dateDetected': (new Date(json['date_detected'])),
        'timelineEvents': ((json['timeline_events'] as Array<any>).map(InfringementEventFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function BrandInfringementToJSON(json: any): BrandInfringement {
      return BrandInfringementToJSONTyped(json, false);
  }

  export function BrandInfringementToJSONTyped(value?: Omit<BrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threat_title': value['threatTitle'],
        'threat_type': BrandInfringementThreatTypeEnumToJSON(value['threatType']),
        'source': value['source'],
        'severity': BrandInfringementSeverityEnumToJSON(value['severity']),
        'confidence_level': value['confidenceLevel'],
        'status': Status7f3EnumToJSON(value['status']),
        'screenshot': value['screenshot'],
        'description': value['description'],
    };
}

